import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { getBadgeColor } from '../../../utils/pro-house-account';
export const PHABadge = ({ locType }) => {
    const badgeLabel = (locType === null || locType === void 0 ? void 0 : locType.toUpperCase()) === 'SHOP' ? 'Shop' : 'Project';
    return (React.createElement(Badge, { "data-testid": "pha-badge", variant: "regular", color: getBadgeColor(locType), size: "small" }, badgeLabel));
};
